import { hot } from 'react-hot-loader/root';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import PageWrapper from '../design-system/PageWrapper';
import PageSection from '../design-system/PageSection';
import Container from '../design-system/Containers';
import Paragraph from '../design-system/Paragraph';
import { HeadingArticle } from '../design-system/Headings';
import {
  Form, Field, Submit,
} from '../design-system/Forms';
import { LinkButton } from '../design-system/Buttons';
import { Grid, GridElement } from '../design-system/Grid';
import RadarHeroPageSection from '../design-system/RadarHeroPageSection';

import phrasesType from '../proptypes/phrases';
import formType from '../proptypes/forms';

const MagicLinkPage = ({
  magicLinkForm,
  phrases,
  signUpPath,
  signInPath,
}) => {
  const [success, setSuccess] = useState(false);

  return (
    <PageWrapper bgDark>
      <RadarHeroPageSection container={false}>
        <Container small>
          <HeadingArticle el="h1">{success ? phrases.successTitle : phrases.title}</HeadingArticle>
        </Container>
      </RadarHeroPageSection>

      <PageSection container={false}>
        <Container small>
          {success ? (
            <Paragraph center primary intro uppercase>{phrases.checkEmail}</Paragraph>
          ) : (
            <Form {...magicLinkForm} inline onSuccess={() => setSuccess(true)}>
              <Field label={phrases.email} name="email" type="email" required />
              <Submit>{phrases.requestMagicLink}</Submit>
            </Form>
          )}
        </Container>
        <Container small mySm>
          <Grid horizontal extent nowrap bright mySm>
            <GridElement w50 center>{phrases.signInWithYourPassword}</GridElement>
            <GridElement w50 center>{phrases.dontHaveAnAccount}</GridElement>
          </Grid>
          <Grid horizontal nowrap bright my0>
            <GridElement w50 center>
              <LinkButton my0 mx0 secondary href={signInPath}>{phrases.signIn}</LinkButton>
            </GridElement>
            <GridElement w50 center>
              <LinkButton my0 mx0 secondary href={signUpPath}>{phrases.signUp}</LinkButton>
            </GridElement>
          </Grid>
        </Container>
      </PageSection>
    </PageWrapper>
  );
};

MagicLinkPage.propTypes = {
  phrases: phrasesType.isRequired,
  magicLinkForm: formType.isRequired,
  signUpPath: PropTypes.string.isRequired,
  signInPath: PropTypes.string.isRequired,
  headerImage: PropTypes.string,
};

MagicLinkPage.defaultProps = {
  headerImage: undefined,
};

export default hot(MagicLinkPage);
